export const products = [
  "Premium 2L",
  "Premium 1L",
  "Premium 500ML",
  "Premium 250ML",
  "Green 1L",
  "Green 500ML",
  "250ML Pouch",
  "Ice Cube",
];

export const cartonSizes = {
  "Premium 2 Litre Bottle": 9,
  "Premium 1 Litre Bottle": 12,
  "Premium 500ML Bottle": 24,
  "Premium 250ML Bottle": 24,
  "Green 500ML Bottle": 24,
};

export const formatDate = (dateObj) => {
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  return `${year}/${month}/${day}`;
};

export const showNotification = (msg) => {
  alert(msg);
};
